import * as ReactBootstrap from 'react-bootstrap'
import React from 'react'

export const LoginAsButton = ({ user }) => {
  const setHeaders = ()=>{
    alert(user.email)
  }

  return (
    <ReactBootstrap.Button
        variant="light"
      className="btn text-dark"
      onClick={setHeaders}
        style={{
          "width": "-webkit-fill-available",
        }}

    >
    Login As
    </ReactBootstrap.Button>
  )
}
